import cn from '@/utils/classNames';
import { adjustImageAsset } from '@/utils/imageUtils';
import styles from './ProfilePicture.module.css';

export enum ProfilePictureSizes {
    Regular = 48,
    Large = 96,
}

interface IProps {
    /** The URL for this picture */
    src?: string;
    /** The alt text. Required for accessibility */
    alt: string;
    /** Height and Width sizes in pixels */
    size?: ProfilePictureSizes;
    className?: string;
}

/**
 * A circular image component.
 */
export const ProfilePicture = ({ src, alt, size = ProfilePictureSizes.Regular, className }: IProps) => {
    let img;
    if (src) {
        img = <img className={styles.image} src={adjustImageAsset(src, size * 2)} alt={alt} />;
    } else {
        const words = alt.split(' ').filter(Boolean);
        // take the first and last words for initials
        const selectedWords = words.length > 2 ? [words[0], words[words.length - 1]] : words;
        const initials = selectedWords.map((word) => word.charAt(0)).join('');
        img = <span className={styles.placeholder}>{initials}</span>;
    }

    return (
        <div style={{ ['--_ProfilePicture-size' as string]: `${size}px` }} className={cn(styles.container, className)}>
            {img}
        </div>
    );
};
